module.exports = __webpack_public_path__ + "img/Region_Gaz.5e33b8f4.png";